<template>
  <div id="main-page">
    <transition name="slide">
      <CollectionViewer v-if="collectionModalVisible" />
    </transition>
    <div class="sections" key="2" v-show="mainPageVisible">
      <Home />
      <Collections />
      <Biography />
      <Footer />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CollectionViewer from "@/components/sections/MainPage/CollectionViewer";

import Home from "@/components/sections/MainPage/Home";
import Collections from "@/components/sections/MainPage/Collections";
import Biography from "@/components/sections/MainPage/Biography";
import Footer from "@/components/global/Footer";

export default {
  name: "MainPage",
  components: {
    Home,
    Collections,
    Biography,
    Footer,
    CollectionViewer
  },
  data() {
    return {
      collectionModalVisible: false,
      mainPageVisible: true
    };
  },
  computed: {
    ...mapState(["global"])
  },
  watch: {
    $route(to, from) {
      let that = this;
      let delay = 0;
      // if (to.path !== "/") {
      //   //add delay to hideMainPage
      //   setTimeout(function() {
      //     that.mainPageVisible = !(
      //       that.$route.params.id && that.$route.params.id.toString()
      //     );
      //   }, 500);
      // } else {
      //   that.mainPageVisible = !(
      //     that.$route.params.id && that.$route.params.id.toString()
      //   );
      // }
      let mainPage = !(
        this.$route.params.id && this.$route.params.id.toString()
      );
      this.mainPageVisible = mainPage;
      this.collectionModalVisible = !mainPage;
      if (mainPage) {
        document.title = "Samir Rehem";
      }
    }
  },
  mounted() {
    this.collectionModalVisible =
      this.$route.params.id && this.$route.params.id.toString();
    this.mainPageVisible = !(
      this.$route.params.id && this.$route.params.id.toString()
    );
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>